import { cn } from '@morpho-org/ui-v6/utils'
import { type ComponentPropsWithoutRef, forwardRef } from 'react'

type DivProps = ComponentPropsWithoutRef<'div'>

type VaultTimelockContainerProps = DivProps & {
  selectable?: boolean
}

const VaultTimelockContainer = forwardRef<HTMLDivElement, VaultTimelockContainerProps>(
  ({ selectable = true, className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'rounded-lg bg-muted',
        selectable && 'hover:cursor-pointer hover:bg-accent',
        className
      )}
      {...props}
    />
  )
)
VaultTimelockContainer.displayName = 'VaultTimelockContainer'

const VaultTimelockHeader = forwardRef<HTMLDivElement, DivProps>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'flex w-full flex-row items-center justify-between border-b-[0.5px] border-border px-sm py-xs',
      className
    )}
    {...props}
  />
))
VaultTimelockHeader.displayName = 'VaultTimelockHeader'

const VaultTimelockRow = forwardRef<HTMLDivElement, DivProps>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'flex w-full flex-row items-center justify-between gap-sm px-sm py-xs',
      className
    )}
    {...props}
  />
))
VaultTimelockRow.displayName = 'VaultTimelockRow'

export const HoverableWrapper = forwardRef<HTMLDivElement, DivProps>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'cursor-pointer overflow-hidden rounded-lg px-xs py-2xs hover:bg-accent',
        className
      )}
      {...props}
    />
  )
)
HoverableWrapper.displayName = 'HoverableWrapper'

export const StyledVaultPendingTimelock = {
  Container: VaultTimelockContainer,
  Header: VaultTimelockHeader,
  Row: VaultTimelockRow
}
